const Hero = () => {
  return (
    <section className="hero__wrapper">
      <div className="hero__container">
        <div className="hero__half">
          <div className="hero__title">Mass delete your social media history quickly & easily</div>
          <div className="hero__body">
            Redact supports all of the most popular services for Social Media and Direct Messaging,
            and we&apos;re always looking to expand our supported services.
          </div>
        </div>
        <div className="hero__half_image">
          <div className="hero__svg_wrapper hero__svg_wrapper--auto">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src="/images/svgs/services.svg"
              alt="Mass delete your social media history quickly & easily"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
